"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptDef = void 0;
exports.handle = handle;
const context_1 = require("../resources/context");
exports.promptDef = {
    name: 'continue-thread',
    description: 'Load full thread context (idea, design, active plan, refs) and return a next-action proposal prompt.',
    arguments: [
        { name: 'weaveSlug', description: 'Weave folder slug', required: true },
        { name: 'threadSlug', description: 'Thread folder slug', required: true },
    ],
};
async function handle(root, args) {
    const weaveSlug = args['weaveSlug'];
    const threadSlug = args['threadSlug'];
    if (!weaveSlug || !threadSlug)
        throw new Error('weaveSlug and threadSlug are required');
    const ctx = await (0, context_1.handleContextResource)(root, `loom://context/thread/${weaveSlug}/${threadSlug}?mode=chat`);
    const contextText = ctx.contents[0].text;
    return {
        description: `Thread context for ${weaveSlug}/${threadSlug}`,
        messages: [
            {
                role: 'user',
                content: { type: 'text', text: contextText },
            },
            {
                role: 'user',
                content: {
                    type: 'text',
                    text: 'Review this thread and propose the next action. Consider the current design, active plan, and any blocked or incomplete steps.',
                },
            },
        ],
    };
}
